export default __webpack_public_path__ + "static/media/picDungTran.2d5c5003.png";